export const shouldLoad = () => document.querySelector('.tabs') !== undefined;